(function() {
	WebBaseAprovLV.renderFavoritesPage = function(props) {
		var Utils = WebBaseAprovLV.Utils;
		var lang = WebBaseAprovLV.lang || 'de';
		var base = (WebBaseAprovLV.config.azureStorageUrl[lang] || '').replace(/\/?$/, '/');
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			return $.Deferred().reject(new Error('Utils missing')).promise();
		}
		var fetchJson = Utils.fetchAsync({ dataType: 'json', cache: true, timeout: 12000 });
		var favMuniIds = Array.from((Utils.FavStoreMuni && Utils.FavStoreMuni.get()) || []);
		var favWebcamIds = Array.from((Utils.FavStoreWebcam && Utils.FavStoreWebcam.get()) || []);
		var favStationIds = Array.from((Utils.FavStoreStation && Utils.FavStoreStation.get()) || []);
		var favPdfIds = Array.from((Utils.FavStorePDF && Utils.FavStorePDF.get()) || []);
		var model = {
			element: null,
			template: 'templates/favorites.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {},
				pageRaw: null,
				navRaw: null,
				nav: null,
				pageContent: null,
				favMunicipalities: [],
				favWebcams: [],
				favStations: [],
				favPdfs: favPdfIds.slice(),
				municipalByDay: {},
				latestMunicipalUpdateISO: null,
				muniAreas: {},
				skyMap: {},
				stationByCode: {},
				sensorTypes: {}
			}
		};
		var pageReq = Utils.getKKData(
			'?system.type=page&elements.url[in]=' +
      encodeURIComponent(props.context.params.page || '') +
      '&depth=1'
		);
		var muniReq = fetchJson(base + 'forecast-data/website/static-data/municipalities.json');
		var valleyReq = fetchJson(base + 'stations-data/website/valley.json');
		var mountainReq = fetchJson(base + 'stations-data/website/mountain.json');
		var waterReq = fetchJson(base + 'stations-data/website/watercourse.json');
		var skyReq = fetchJson(base + 'forecast-data/website/static-data/sky_conditions.json');
		var tlLang = (/^(de|it|en|lld)$/.test(lang) ? lang : 'de');
		var tlReq = fetchJson(
			base + 'forecast-data/website/southtyrol/' + tlLang + '_144000000.json'
		);
		var sensorTypeReq = fetchJson(base + 'stations-data/website/sensor_type.json');
		function parseNum(v) {
			var n = Number(v);
			return isFinite(n) ? n : null;
		}
		return $.when(
			pageReq,
			muniReq,
			valleyReq,
			mountainReq,
			waterReq,
			skyReq,
			tlReq,
			sensorTypeReq
		)
		.then(function(
			pageXhr,
			muniX,
			valleyX,
			mountainX,
			waterX,
			skyX,
			tlX,
			sensorTypeX
		) {
			var pageRaw = Array.isArray(pageXhr) ? (pageXhr[0] || {}) : (pageXhr || {});
			model.data.pageRaw = pageRaw;
			var vmArr = Utils.getKKViewModel ? Utils.getKKViewModel(pageRaw) : [pageRaw];
			model.data.pageContent = vmArr[0] || {};
			model.data.nav = {};
			var municipalitiesRaw = (Array.isArray(muniX) && Array.isArray(muniX[0]))
				? muniX[0]
				: (muniX || []);
			var municipalities =
          (Utils.localizeMunicipalRecords &&
            Utils.localizeMunicipalRecords(municipalitiesRaw, lang)) ||
          municipalitiesRaw;
			var muniById = {};
			municipalities.forEach(function(m) {
				var id = (m && (m.venue_id != null ? m.venue_id : m.id)) != null
					? String(m.venue_id != null ? m.venue_id : m.id)
					: null;
				if (!id) {return;}
				muniById[id] = m;
			});
			model.data.muniAreas = muniById;
			var municipalByDay = {};
			var latestUpdateISO = null;
			var tlRaw = tlX;
			if (Array.isArray(tlX)) {
				tlRaw = tlX[0] || {};
			}
			var pubs = [];
			if (tlRaw && tlRaw.data && Array.isArray(tlRaw.data.bulletins)) {
				pubs = [tlRaw];
			}
			(pubs || [])
			.map(function(r) {
				return Array.isArray(r) ? r[0] : r;
			})
			.filter(function(r) {
				return r && r.data && Array.isArray(r.data.bulletins);
			})
			.forEach(function(pub) {
				var lu =
              (pub && pub.meta && (pub.meta.last_update || pub.meta.date)) || null;
				if (lu && (!latestUpdateISO || new Date(lu) > new Date(latestUpdateISO))) {
					latestUpdateISO = lu;
				}
				(pub.data.bulletins || []).forEach(function(b) {
					var iso = (b && b.period && b.period.start
						? (Utils.localIsoDayFromUTC
							? Utils.localIsoDayFromUTC(b.period.start)
							: new Date(b.period.start).toISOString().slice(0, 10))
						: '');
					if (!iso) {
						return;
					}
					if (!municipalByDay[iso]) {
						municipalByDay[iso] = { summary: null, municipalities: [], meta: {} };
					}
					if (!municipalByDay[iso].meta || !municipalByDay[iso].meta.last_update) {
						municipalByDay[iso].meta = { last_update: lu || null };
					}
					if (!municipalByDay[iso].summary) {
						var T = b.temperatures || b.temperature || {};
						var Tmin = T && T.min ? T.min : null;
						var Tmax = T && T.max ? T.max : null;
						municipalByDay[iso].summary = {
							id_time_layout: b.id_time_layout,
							title: b.title || '',
							conditions: b.conditions || '',
							weather: b.weather || '',
							temperatureText: b.temperature || '',
							reliability: b.reliability,
							skyKey: String(b.skyCondition || '').toUpperCase(),
							tminLow: parseNum(Tmin && Tmin.low),
							tminHigh: parseNum(Tmin && Tmin.high),
							tmaxLow: parseNum(Tmax && Tmax.low),
							tmaxHigh: parseNum(Tmax && Tmax.high)
						};
					}
					var metrics = Array.isArray(b.municipalityMetrics)
						? b.municipalityMetrics
						: [];
					for (var i = 0; i < metrics.length; i++) {
						var m = metrics[i];
						if (!m || m.venueId == null) {
							continue;
						}
						municipalByDay[iso].municipalities.push({
							venueId: String(m.venueId),
							sky_condition: m.sky_condition || null,
							temperature_minimum: parseNum(m.temperature_minimum),
							temperature_maximum: parseNum(m.temperature_maximum),
							rain_fall: parseNum(m.rain_fall),
							rain_probability: parseNum(m.rain_probability),
							sunshine_duration: parseNum(m.sunshine_duration),
							wind_speed: parseNum(m.wind_speed),
							wind_gust: parseNum(m.wind_gust),
							wind_direction: m.wind_direction == null ? null : m.wind_direction,
							snow_level: parseNum(m.snow_level),
							fresh_snow: parseNum(m.fresh_snow),
							freezing_level: parseNum(m.freezing_level)
						});
					}
				});
			});

			model.data.municipalByDay = municipalByDay;
			model.data.latestMunicipalUpdateISO = latestUpdateISO || null;
			var skyRaw = Array.isArray(skyX) ? skyX : (skyX && skyX[0]) || [];
			var skyMap =
          (Utils.buildSkyMap && Utils.buildSkyMap(skyRaw, lang)) || {};
			model.data.skyMap = skyMap;
			model.data.favMunicipalities = favMuniIds.map(function(id) {
				id = String(id);
				var m = muniById[id] || { venue_id: id };
				return m;
			});
			var stationsPayload = []
			.concat((valleyX && valleyX.stations) || (valleyX && valleyX[0] && valleyX[0].stations) || [])
			.concat((mountainX && mountainX.stations) || (mountainX && mountainX[0] && mountainX[0].stations) || [])
			.concat((waterX && waterX.stations) || (waterX && waterX[0] && waterX[0].stations) || []);
			var stations = [];
			if (Array.isArray(stationsPayload)) {
				stations = stationsPayload.map(function(s) {
					if (!s) {return s;}
					var name;
					switch (lang) {
						case 'it':
							name = s.name_it || s.name_de || s.name_en || s.name_lld;
							break;
						case 'lld':
							name = s.name_lld || s.name_de || s.name_it || s.name_en;
							break;
						case 'en':
							name = s.name_en || s.name_de || s.name_it || s.name_lld;
							break;
						case 'de':
						default:
							name = s.name_de || s.name_it || s.name_en || s.name_lld;
							break;
					}
					var statusDesc;
					switch (lang) {
						case 'it':
							statusDesc = s.status_it || s.status_de || s.status_en || s.status_lld;
							break;
						case 'lld':
							statusDesc = s.status_lld || s.status_de || s.status_it || s.status_en;
							break;
						case 'en':
							statusDesc = s.status_en || s.status_de || s.status_it || s.status_lld;
							break;
						case 'de':
						default:
							statusDesc = s.status_de || s.status_it || s.status_en || s.status_lld;
							break;
					}
					s.NAME = name || s.code || '';
					s.SCODE = s.code || '';
					s.STATUSDESC = statusDesc || '';
					s.elevation =
              s.elevation != null
              	? parseInt(s.elevation, 10)
              	: (s.ALT != null ? parseFloat(s.ALT) : null);
					return s;
				});
				stations.sort(function(a, b) {
					return String(a.NAME || '').localeCompare(String(b.NAME || ''));
				});
			}
			var stationByScode = {};
			stations.forEach(function(s) {
				if (!s || !s.code) {return;}
				stationByScode[String(s.code)] = s;
			});
			model.data.stationByCode = stationByScode;
			var sensorTypesRaw =
          (sensorTypeX && sensorTypeX.sensor_type) ||
          (Array.isArray(sensorTypeX) &&
            sensorTypeX[0] &&
            sensorTypeX[0].sensor_type) ||
          [];
			var sensorTypesByCode = {};
			if (Array.isArray(sensorTypesRaw)) {
				sensorTypesRaw.forEach(function(st) {
					if (st && st.code != null) {
						sensorTypesByCode[String(st.code)] = st;
					}
				});
			}
			model.data.sensorTypes = sensorTypesByCode;
			model.data.favStations = favStationIds.map(function(id) {
				id = String(id);
				return stationByScode[id] || { code: id };
			});
			model.data.favWebcams = favWebcamIds.slice();
			model.data.favPdfs = favPdfIds.slice();
			model.element = $('#content');
			return Utils.transitionTo(model);
		})
		.promise();
	};
})();
